/* eslint eqeqeq: "off" */

/**
 * Vendor
 */
import React from 'react';
import { createRoot } from 'react-dom/client';

/**
 * App
 */
import './config/environment'; // Load environment configuration
import './i18n';
import './styles/tailwind.css'; // Load Tailwind CSS
import App from 'app/App';
import 'shared/logging/log-proto';
import { AppProviders } from './app/providers';

/**
 * CUSTOM STYLE
 *
 * TODO: This one breaks for now cause of sass
 */
// import 'App.scss';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root not found');
}

const root = createRoot(container);

root.render(
  <AppProviders>
    <App />
  </AppProviders>,
);

